<template>
  <div class="salesforce">
    <div class="widget">
      <div class="widget-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="state">
            <h4>
              Salesforce CRM
              <small v-if="!activeIntegration">(Inativo)</small>
            </h4>
          </div>
          <div class="icon">
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon add-margin-right="20px" />
              <div v-if="activeIntegration">
                <font
                  title="Configurações"
                  size="6"
                  color="black"
                  @click.prevent="toggleUpdateIntegration()">
                  <i class="ik ik-settings" />
                </font>
              </div>
              <div v-else>
                <font
                  title="Configurações"
                  size="6"
                  color="gray">
                  <i class="ik ik-settings" />
                </font>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-small mt-10 d-block">
            <toggle-button
              tag="salesforce"
              class="mb-1"
              :width="90"
              :height="30"
              :font-size="15"
              :value="activeIntegration"
              :sync="true"
              :labels="{checked: 'Ativo', unchecked: 'Ativar'}"
              @change="toggleIntegration" />
          </small>
          <font
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="confirmDelete"
      ref="confirmDelete"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4 class="modal-title">Você tem certeza que deseja remover a integração com o Salesforce CRM?</h4>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="deleteIntegration">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="updateIntegration"
      ref="updateIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Configurar Salesforce CRM</h4>
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon />
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div class="modal-body">
            <ErrorAlert :error="error" />
            <div v-if="!activeIntegration">
              <div class="form-group row">
                <label
                  for="franchisee"
                  class="col-sm-4 col-form-label">Franqueado?</label>
                <div class="col-sm-8">
                  <select
                    class="form-control"
                    id="franchisee"
                    ref="franchisee"
                    v-model="franchisee">
                    <option
                      hidden
                      :value="null"
                      disabled>
                      Escolha entre Sim e Não
                    </option>
                    <option
                    :value="true">
                      Sim
                    </option>
                    <option
                    :value="false">
                      Não
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div v-if="franchisee && !activeIntegration">
              <div class="form-group row">
                <label
                  for="accountType"
                  class="col-sm-4 col-form-label">Domínio?</label>
                <div class="col-sm-8">
                  <select
                    class="form-control"
                    id="accountType"
                    ref="accountType"
                    v-model="accountType">
                    <option
                    value="default">
                      Padrão
                    </option>
                    <option
                    value="customFranchisee">
                      Customizado
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label
                  for="salesforceSubdomain"
                  class="col-sm-4 col-form-label">Subdomínio</label>
                <div class="col-sm-8">
                  <div class="input-group">
                    <span
                      v-if="accountType === 'default'"
                      class="input-group-prepend">
                      <span class="input-group-text">https://</span>
                    </span>
                    <input
                      id="salesforceSubdomain"
                      ref="salesforceSubdomain"
                      type="text"
                      class="form-control"
                      tabindex="1"
                      v-model="subdomain">
                    <span
                      v-if="accountType === 'default'"
                      class="input-group-append">
                      <span class="input-group-text">.my.site.com</span>
                    </span>
                  </div>
                </div>
              </div>
              <p class="form-text mt-1 text-center font-text-large">
                * Caso o seu domínio seja customizado e ainda não tenha sido cadastrado, iremos realizar essa ação em até <strong>7 dias úteis</strong>.
              </p>
            </div>
            <div v-if="activeIntegration">
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Usuário Salesforce</label>
                <div class="col-sm-8">
                  <select
                    class="form-control"
                    id="userId"
                    v-model="userId">
                    <option
                      v-for="option in usersOptions"
                      :key="option.value"
                      :value="option.value">
                      {{ option.text }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Prioridade da Chamada</label>
                <div class="col-sm-8">
                  <select
                    class="form-control"
                    id="callPriority"
                    v-model="callPriority">
                    <option
                      v-for="option in prioritiesOptions"
                      :key="option.value"
                      :value="option.value">
                      {{ option.text }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Chamada Atendida</label>
                <div class="col-sm-8">
                  <select
                    class="form-control"
                    id="callStatusAnswered"
                    v-model="callStatusAnswered">
                    <option
                      v-for="option in callStatusesOptions"
                      :key="option.value"
                      :value="option.value">
                      {{ option.text }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-4 col-form-label">Chamada Não Atendida</label>
                <div class="col-sm-8">
                  <select
                    class="form-control"
                    id="callStatusNotAnswered"
                    v-model="callStatusNotAnswered">
                    <option
                      v-for="option in callStatusesOptions"
                      :key="option.value"
                      :value="option.value">
                      {{ option.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="!configReady"
                @click.prevent="saveIntegration">{{ labelSubmit }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="successIntegration"
      ref="successIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Salesforce atualizada com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="uninstallIntegration"
      ref="uninstallIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Salesforce removida com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <tutorial-video-modal
      ref="tutorialSalesforceCrm"
      title="Tutorial Salesforce"
      video-url="https://www.youtube.com/embed/p7TeymBHjEg?si=Psao0bmlTRYTgaV1" />
  </div>
</template>
<script>
import loopback from '@/services/loopback'
import ArtificialIntelligenceIcon from '@/components/Common/ArtificialIntelligenceIcon.vue'
import TutorialVideoModal from '@/components/Common/TutorialVideoModal.vue'
export default {
  name: 'IntegrationSalesforce',
  components: {
    ArtificialIntelligenceIcon,
    TutorialVideoModal
  },
  data () {
    return {
      error: null,
      integration: null,
      userId: null,
      usersOptions: [],
      callPriority: null,
      prioritiesOptions: [],
      callStatusAnswered: null,
      callStatusNotAnswered: null,
      callStatusesOptions: [],
      subdomain: null,
      franchisee: null,
      accountType: 'default',
      integrationId: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadIntegration().then(res => {
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.get('success') === 'salesforce') {
          this.loadUsers().then(_ => {
            this.loadPriorities().then(_ => {
              this.loadCallStatuses().then(_ => {
                $(this.$refs.updateIntegration).modal('show')
                this.removeUrlParam('success')
              })
            })
          })
          $(this.$refs.updateIntegration).modal('show')
          this.removeUrlParam('success')
        }
      })
    })
  },
  methods: {
    removeUrlParam (param) {
      const url = new URL(window.location.href)
      url.searchParams.delete(param)
      window.history.replaceState({}, document.title, url.toString())
    },
    loadIntegration () {
      this.loading = true
      return new Promise(resolve => {
        return loopback
          .get(`/integrations?filter[where][gateway]=salesforce`)
          .then(integrations => {
            this.integration = integrations.pop()
            if (this.integration && this.integration.metadata) {
              if (this.integration.metadata.userId) this.userId = this.integration.metadata.userId
              if (this.integration.metadata.callPriority) this.callPriority = this.integration.metadata.callPriority
              if (this.integration.metadata.callStatusAnswered) this.callStatusAnswered = this.integration.metadata.callStatusAnswered
              if (this.integration.metadata.callStatusNotAnswered) this.callStatusNotAnswered = this.integration.metadata.callStatusNotAnswered
              if (this.integration.metadata.franchisee) this.franchisee = this.integration.metadata.franchisee
              if (this.integration.metadata.accountType) this.accountType = this.integration.metadata.accountType
              if (this.integration.metadata.subdomain) this.subdomain = this.integration.metadata.subdomain
            }
            this.loading = false
            return resolve()
          })
          .catch(err => {
            this.loading = false
            this.$emit('onError', err)
          })
      })
    },
    saveIntegration () {
      return new Promise(resolve => {
        this.error = null

        if (!this.configReady) {
          this.error = {
            message: 'Houve um erro ao salvar a integração. Por favor, tente novamente.'
          }
          return resolve()
        }
        const integrationParams = {
          gateway: 'salesforce',
          webhook: true,
          webhookConstraint: {
            metadata: {
              api4comGateway: 'salesforce'
            }
          },
          metadata: {
            webhookUrl: `${process.env.API4COM_BASE_URL_API}${process.env.API4COM_VERSION_API}/integrations/webhook`,
            webhookVersion: 'v1.4',
            webhookTypes: ['channel-hangup']
          }
        }

        if (this.integration) integrationParams.id = this.integration.id

        if (this.integration && this.integration.metadata) integrationParams.metadata = Object.assign(this.integration.metadata, integrationParams.metadata)

        if (this.userId) integrationParams.metadata.userId = this.userId
        else delete integrationParams.metadata.userId

        if (this.callPriority) integrationParams.metadata.callPriority = this.callPriority
        else delete integrationParams.metadata.callPriority

        if (this.callStatusAnswered) integrationParams.metadata.callStatusAnswered = this.callStatusAnswered
        else delete integrationParams.metadata.callStatusAnswered

        if (this.callStatusNotAnswered) integrationParams.metadata.callStatusNotAnswered = this.callStatusNotAnswered
        else delete integrationParams.metadata.callStatusNotAnswered

        if (this.franchisee) {
          integrationParams.metadata.franchisee = this.franchisee
          if (this.accountType === 'customFranchisee') integrationParams.metadata.accountType = 'customFranchisee'
          else integrationParams.metadata.accountType = 'default'
          if (this.subdomain) integrationParams.metadata.subdomain = this.subdomain
          else delete integrationParams.metadata.subdomain
        } else {
          integrationParams.metadata.subdomain = 'https://login.salesforce.com'
          delete integrationParams.metadata.accountType
          delete integrationParams.metadata.franchisee
        }
        loopback
          .patch('/integrations', integrationParams)
          .then(integration => {
            if (!this.activeIntegration) {
              this.usersOptions = []
              this.userId = ''
              this.prioritiesOptions = []
              this.callPriority = ''
              this.callStatusesOptions = []
              this.callStatusAnswered = ''
              this.callStatusNotAnswered = ''
              return this.requestAuthorization(integration)
            }
            this.integration = Object.assign({}, integration)
            $(this.$refs.updateIntegration).modal('hide')
            $(this.$refs.successIntegration).modal('show')
            return resolve()
          })
          .catch(err => {
            this.error = err
          })
      })
    },
    toggleIntegration (event) {
      if (event.value === true) {
        $(this.$refs.updateIntegration).modal('show')
      } else {
        $(this.$refs.confirmDelete).modal('show')
      }
    },
    toggleUpdateIntegration () {
      this.error = null
      if (this.activeIntegration && !this.integration.metadata.userId) {
        this.error = { message: 'Houve um erro ao salvar a integração. Por favor, tente novamente.' }
        this.usersOptions = []
        this.prioritiesOptions = []
        this.callStatusesOptions = []
        this.userId = null
        this.callPriority = null
        this.callStatusAnswered = null
        this.callStatusNotAnswered = null
      }
      $(this.$refs.updateIntegration).modal('show')
      this.loadUsers().then(_ => {
        this.loadPriorities().then(_ => {
          this.loadCallStatuses().then(_ => {
          }).catch(err => {
            this.$emit('onError', err)
          })
        }).catch(err => {
          this.$emit('onError', err)
        })
      }).catch(err => {
        this.$emit('onError', err)
      })
    },
    deleteIntegration () {
      if (!this.integration) return
      loopback
        .delete(`/integrations/${this.integration.id}`)
        .then(_ => {
          this.integration = null
          this.usersOptions = []
          this.userId = ''
          this.prioritiesOptions = []
          this.callStatusesOptions = []
          this.callPriority = ''
          this.callStatusAnswered = null
          this.callStatusNotAnswered = null
          this.subdomain = null
          this.franchisee = null
          this.accountType = 'default'
          this.error = null
          $(this.$refs.uninstallIntegration).modal('show')
        })
        .finally(_ => {
          this.integration = null
          this.usersOptions = []
          this.userId = ''
          this.prioritiesOptions = []
          this.callPriority = ''
          this.callStatusesOptions = []
          this.callStatusAnswered = null
          this.callStatusNotAnswered = null
          $(this.$refs.confirmDelete).modal('hide')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    requestAuthorization (integration) {
      return new Promise(() => {
        if (integration && integration.metadata) {
          if (integration.metadata.userId) this.userId = integration.metadata.userId
          if (integration.metadata.callPriority) this.callPriority = integration.metadata.callPriority
          if (integration.metadata.callStatusAnswered) this.callStatusAnswered = integration.metadata.callStatusAnswered
          if (integration.metadata.callStatusNotAnswered) this.callStatusNotAnswered = integration.metadata.callStatusNotAnswered
          if (integration.metadata.franchisee) this.franchisee = integration.metadata.franchisee
          if (integration.metadata.accountType) this.accountType = integration.metadata.accountType
          if (integration.metadata.subdomain) this.subdomain = integration.metadata.subdomain
          let url = `/integrations/salesforce/authorize-link?state=${integration.id}`
          if (this.franchisee && this.accountType === 'customFranchisee' && this.subdomain) {
            url += `&subdomain=${encodeURIComponent(this.subdomain)}`
          }
          if (this.franchisee && this.accountType === 'default' && this.subdomain) {
            const subdomain = `https://${this.subdomain}.my.site.com`
            url += `&subdomain=${encodeURIComponent(subdomain)}`
          }
          return loopback
            .get(url)
            .then(link => {
              window.open(link, '_self')
            })
            .catch(err => { this.$emit('onError', err) })
        }
      })
    },
    loadUsers () {
      return new Promise(resolve => {
        return loopback
          .get(`/integrations/salesforce/users`)
          .then(users => {
            if (users && users.length > 0) {
              this.usersOptions = []
              if (!this.userId) this.userId = users[0].Id
              users.filter(user => user.IsActive).forEach(user => {
                let text = user.Name
                if (user.Email) text += ` (${user.Email})`
                this.usersOptions.push({
                  value: user.Id,
                  text
                })
              })
              return resolve()
            } else {
              return resolve()
            }
          })
          .catch(err => {
            this.errorHandle(err)
          })
      })
    },
    loadPriorities () {
      return new Promise(resolve => {
        return loopback
          .get(`/integrations/salesforce/priorities`)
          .then(priorities => {
            if (priorities && priorities.length > 0) {
              this.prioritiesOptions = []
              if (!this.callPriority) this.callPriority = priorities[0].label
              priorities.forEach(priority => {
                this.prioritiesOptions.push({
                  value: priority.label,
                  text: priority.label
                })
              })
              return resolve()
            } else {
              return resolve()
            }
          })
          .catch(err => this.errorHandle(err))
      })
    },
    loadCallStatuses () {
      return new Promise(resolve => {
        return loopback
          .get(`/integrations/salesforce/call-statuses`)
          .then(statuses => {
            if (statuses && statuses.length > 0) {
              this.callStatusesOptions = []
              if (!this.callStatusAnswered) this.callStatusAnswered = statuses[0].value
              if (!this.callStatusNotAnswered) this.callStatusNotAnswered = statuses[0].value
              statuses.forEach(status => {
                this.callStatusesOptions.push({
                  value: status.value,
                  text: `${status.value} (${status.isClosed ? 'FECHADO' : 'ABERTO'})`
                })
              })
              return resolve()
            } else {
              return resolve()
            }
          })
          .catch(err => this.errorHandle(err))
      })
    },
    errorHandle (err) {
      console.error(err)
      this.error = {
        message: 'Houve um problema com a autenticação da integração. Talvez seja necessário reinstalar essa integração.'
      }
    },
    openTutorial () {
      this.$refs.tutorialSalesforceCrm.open()
    }
  },
  computed: {
    activeIntegration () {
      return this.integration && this.integration.gateway === 'salesforce'
    },
    labelSubmit () {
      return this.activeIntegration ? 'Salvar' : 'Ativar'
    },
    configReady () {
      if (this.loading) return false

      if (this.activeIntegration) {
        return !!this.userId && !!this.callPriority && !!this.callStatusAnswered && !!this.callStatusNotAnswered
      }

      if (this.franchisee === true) {
        return !!this.subdomain
      }

      if (this.franchisee === false) {
        return true
      }

      return false
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/Salesforce.vue